"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getShortContractAddress = void 0;
const contractString_1 = require("../contractString");
function getShortContractAddress(address) {
    return (0, contractString_1.contractString)(address, 14);
}
exports.getShortContractAddress = getShortContractAddress;
